<template>
  <b-row>
    <b-col>     
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
          </div>
        </section>
      </b-card>

      <b-card>
        <form-wizard  :title="wizard.title"
                      :subtitle="wizard.subtitle"
                      nextButtonText="Siguiente"
                      backButtonText="Atrás"
                      finishButtonText="Guardar"
                      color="#2f353a"
                      shape="tab"
                      @on-complete="preSave"
                      class="crud-sales-wizard"
                      ref="wizard">

          <tab-content title="General" icon="fa fa-edit" :before-change="saleValidCrudGeneral">          
            <b-row>      
              <b-col md="4">
                <FindObject render="search"
                            type="customers" 
                            @select-object="loadCustomers($event)" 
                            :valueID="crud.form.customers_id"
                            :where="conditionCustomersActive"
                            :key="crud.form.customers_id"
                            ref="searchCustomer" 
                            title="Buscador (F2)" />                 
              </b-col>                  
              <b-col md="4">
                <b-form-group label="Fecha">
                  <b-form-datepicker size="sm" v-model="crud.form.date" placeholder="Fecha" local="es" :readonly="true" :disabled="disabledDates"></b-form-datepicker>                      
                </b-form-group>            
              </b-col>
              <b-col md="4">
                <b-form-group label="Fecha Vencimiento">
                  <b-form-datepicker size="sm" v-model="crud.form.date_expiration" placeholder="Fecha Vencimiento" local="es" :readonly="true" :disabled="disabledDates"></b-form-datepicker>                      
                </b-form-group>            
              </b-col>
            </b-row>              
            <b-row> 
              <b-col md="4">
                <FindObject render="search"
                            type="erpPointsSales" 
                            auto-select-single
                            display="full_identification"
                            @select-object="loadPointsSales($event)" 
                            :valueID="crud.form.points_sales_id"
                            :key="crud.form.points_sales_id"
                            :where="conditionPointsSalesActive" />                 
              </b-col>                              
              <b-col md="4">
                <FindObject render="search"
                            type="erpMethodsPayment" 
                            auto-select-single
                            @select-object="loadMethodsPayment($event)" 
                            :valueID="crud.form.methods_payment_id"
                            :key="crud.form.methods_payment_id" />                 
              </b-col>                 
              <b-col md="4">
                <FindObject render="search"
                            type="priceList" 
                            @select-object="loadPriceList($event)" 
                            :valueID="crud.form.price_list_id"
                            :key="crud.form.price_list_id"
                            :where="conditionPriceListActive" />                 
              </b-col>                           
            </b-row>
            <b-row v-if="parameters.haveAcopio && crud.form.selectTypeVoucher!='notacredito'">
              <b-col md="4">
                <FindObject render="search"
                            type="erpMethodsAcopio" 
                            @select-object="loadMethodsAcopio($event)" 
                            :valueID="crud.form.methods_acopio_id"
                            :key="crud.form.methods_acopio_id" 
                            :disabled="crud.form.id>0 || invoiceFrom" />                 
              </b-col>                 
            </b-row>            
            <b-row v-if="balanceCurrentAccount<0">
              <b-col>
                <b-alert show variant="danger">
                  <AppIcon name="exclamation-triangle" class="mr-1" />Se encontró saldo a favor del cliente: <b>({{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency}).format(balanceCurrentAccount)}})</b>
                </b-alert>
              </b-col>
            </b-row>  

            <b-row v-if="crud.form.points_sales && !crud.form.points_sales.nd">
              <b-col>
                <div v-if="crud.form.points_sales.status">
                  <b-alert show variant="info" v-if="crud.form.points_sales.afip_production">
                    Punto de venta conectado a los servidores de ARCA <b>"EN PRODUCCIÓN"</b>
                  </b-alert>
                  <b-alert show variant="warning" v-else>
                    Punto de venta conectado a los servidores de ARCA <b>"HOMOLOGACION"</b>
                  </b-alert>                  
                </div>
                <div v-else>
                  <b-alert show variant="danger">
                    El punto de venta está <b>INACTIVO</b>
                  </b-alert>
                </div>
              </b-col>
            </b-row>              
          </tab-content>

          <tab-content title="Detalle" icon="fa fa-list" :before-change="saleValidCrudDetail">          
            <b-row>
              <b-col lg="12" md="12" sm="12">             
                  <Detail :customer_id="crud.form.customers_id" 
                          :price_list_id="crud.form.price_list_id"                   
                          :disable-customer-price-list-fallback="crud.form.disable_customer_price_list_fallback"
                          @load-detail-products="setDetailItems($event, 'products')" 
                          @load-detail-products-compound="setDetailItems($event, 'productsCompound')" 
                          @load-detail-services="setDetailItems($event, 'services')" 
                          @load-detail-concepts="setDetailItems($event, 'concepts')" 
                          :detailProducts="crud.form.detailProducts"
                          :detailProductsCompound="crud.form.detailProductsCompound"
                          :detailServices="crud.form.detailServices"
                          :detailConcepts="crud.form.detailConcepts"
                          :hideConcepts="!access.elements.viewDetailTabConcepts"
                          :hideProducts="!access.elements.viewDetailTabProducts"
                          :hideProductsCompound="!access.elements.viewDetailTabProductsCompound"
                          :hideServices="!access.elements.viewDetailTabServices"
                          :key="'detailInvoice_'+itemDetailForceUpdate"
                          :forceUpdate="itemDetailForceUpdate" 
                          :validItemDuplicatedProduct="false"
                          :validItemDuplicatedConcept="false"
                          :barcodeAddAutomaticProduct="true" 
                          :editPrice="!notEditPrice"
                          :methodPayment="crud.form.methods_payment" />                  
                  
                  <b-row class="mt-0 pt-1 pl-3 pr-3 crud-sales-detail-options" align-v="end">
                    <b-col md="6" class="mb-0" v-if="showRemits">                      
                      <b-form-checkbox 
                        v-if="crud.form.types_vouchers && crud.form.types_vouchers.type_balance == '+'"
                        v-model="crud.form.generateRemits"
                        switch 
                        size="sm" 
                        class="pull-left">
                        <b>Generar Remito</b> <i>(Descuenta Stock)</i>
                      </b-form-checkbox>
                    </b-col>   
                    <b-col md="6" class="mb-0" v-if="showCheckNotIva">                      
                      <b-form-checkbox                         
                        v-model="crud.form.not_iva"
                        switch 
                        size="sm" 
                        class="pull-right">
                        <b>Precios sin IVA</b>
                      </b-form-checkbox>
                    </b-col>                        
                  </b-row>
                  <b-row class="pl-3 pr-3 pb-1 mt-3" align-v="end">
                    <b-col md="2" class="mb-2 mb-md-0">
                      <div class="crud-sales-stat">
                        <span class="crud-sales-stat__label">Items</span>
                        <span class="crud-sales-stat__value">{{this.getCantItemSale}}</span>
                      </div>
                    </b-col>
                    <b-col md="6">
                      <div class="text-center"
                           v-if="crud.form.customers && crud.form.customers.data_fiscal && crud.form.customers.data_fiscal.fiscal_conditions_id == 5">

                        <b-link href="javascript:void(0);"
                                @click="showCustomerIdentification = true"
                                v-if="!showCustomerIdentification">
                          <AppIcon name="person" class="mr-1" />Modificar datos del consumidor final
                        </b-link>

                        <b-card
                          id="container_consumer_indentification"
                          class="mb-0"
                          no-body
                          v-if="showCustomerIdentification">
                          <div slot="header" class="app-modal-header py-2">
                            <span class="app-modal-header__icon"><AppIcon name="person" /></span>
                            <h5 class="app-modal-header__title" style="font-size:14px;">Datos Consumidor Final</h5>
                          </div>

                          <b-row class="pl-3 pr-3 pt-1 pb-2">
                            <b-col md="6">                
                              <b-form-group label="Nombre y Apellido" class="mb-0">
                                <b-form-input type="text"
                                              size="sm"
                                              v-model="crud.form.customer_name"
                                              required
                                              placeholder="Nombre y Apellido">
                                </b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col md="6">
                              <b-form-group label="DNI" class="mb-0">
                                <b-form-input type="text"
                                              size="sm"
                                              v-model="crud.form.customer_document_number"
                                              required
                                              placeholder="DNI">
                                </b-form-input>
                              </b-form-group>                                
                            </b-col>      
                            <b-col md="12" class="mt-1">
                              <b-button variant="outline-dark" 
                                        size="sm" 
                                        class="w-100" 
                                        @click="showCustomerIdentification = false">
                                Listo
                              </b-button>
                            </b-col>              
                          </b-row>
                        </b-card>
                        
                      </div>
                    </b-col>
                    <b-col md="4" class="mb-2 mb-md-0" v-if="getCurrencySale">
                      <div class="crud-sales-totals">
                        <div class="crud-sales-totals__row">
                          <span class="crud-sales-totals__label">Subtotal</span>
                          <span class="crud-sales-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencySale}).format(totals.subtotal)}}</span>
                        </div>
                        <div class="crud-sales-totals__row">
                          <span class="crud-sales-totals__label">Descuento</span>
                          <div class="crud-sales-totals__discount-group">
                            <div class="crud-sales-totals__discount">
                              <app-text-input v-model="crud.form.percentage_discount"
                                              type="number"
                                              min="0"
                                              max="100"
                                              step="1"
                                              size="sm"
                                              @change="validDiscounts()"/>
                              <span class="crud-sales-totals__discount-suffix">%</span>
                            </div>
                            <span class="crud-sales-totals__value" :class="{'text-danger': parseFloat(totals.discount) > 0}">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencySale}).format(totals.discount)}}</span>
                          </div>
                        </div>
                        <div class="crud-sales-totals__row">
                          <span class="crud-sales-totals__label">Subtotal</span>
                          <span class="crud-sales-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencySale}).format(totals.subtotal_discount)}}</span>
                        </div>
                        <div class="crud-sales-totals__row">
                          <span class="crud-sales-totals__label">IVA</span>
                          <span class="crud-sales-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencySale}).format(totals.iva)}}</span>
                        </div>
                        <div class="crud-sales-totals__row crud-sales-totals__row--total">
                          <span class="crud-sales-totals__label">Total</span>
                          <span class="crud-sales-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencySale}).format(totals.total)}}</span>
                        </div>
                        <div class="crud-sales-totals__row crud-sales-totals__row--total" v-if="crud.form.methods_payment && parseFloat(crud.form.methods_payment.surcharge) > 0">
                          <span class="crud-sales-totals__label">{{this.crud.form.methods_payment.name}} ({{ this.crud.form.methods_payment.surcharge }}%)</span>
                          <span class="crud-sales-totals__value text-primary">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencySale}).format(totals.total_surcharge)}}</span>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="pl-3 pr-3 pb-1" v-if="showMethodPaymentOptions">
                    <b-col md="12" class="text-right pr-0">
                      <b-button variant="outline-info"
                                size="sm"
                                @click="showSurchargeMethodPayment()">
                        <AppIcon name="money" class="mr-1" />
                        Otras Condiciones de Pago
                      </b-button>
                    </b-col>
                  </b-row>
                  
              </b-col>        
            </b-row>
          </tab-content>

          <tab-content title="Asiento Contable" icon="fa fa-balance-scale" :before-change="salesValidCrudAccounting" v-if="showContabilidad"> 
            <div v-if="contabilidad.render" :key="'accounting_' + itemAccountingForceUpdate">
              <AccountingEntries  :typeDebe="contabilidad.typeDebe"
                                  :typeHaber="contabilidad.typeHaber"
                                  :defaultDebe="contabilidad.defaultDebe"
                                  :defaultHaber="contabilidad.defaultHaber"
                                  :reference="contabilidad.reference"
                                  :amountTotal="contabilidad.amountTotal"
                                  @getAsiento="getAsiento($event)" />         
            </div>
          </tab-content>

        </form-wizard>
      </b-card>

      <b-row>
        <b-col>
          <b-card body-class="py-2">
            <div class="list-view-footer">
              <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
                <AppIcon name="back" />
                Volver
              </b-button>
              <b-button type="button" variant="warning" size="sm" @click="cancel">
                <AppIcon name="refresh" />
                Reiniciar
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <!--
      ###########################
      ######### PRINTER #########
      ###########################
      -->
      <Printer v-if="crud.print.id && crud.print.mode == 'pdf'" 
              :reference="crud.print.reference" 
              :registerID="crud.print.id"
              :key="'pdf-' + crud.print.key"
              :manyFormat="true"/>

      <EscposPrinter v-if="crud.print.id && crud.print.mode == 'thermal_printer'" 
                     :reference="crud.print.reference" 
                     :registerID="crud.print.id"
                     :key="'thermal-printer-' + crud.print.key"
                     :manyFormat="true"
                     :direct="true"/>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD FINANCE -->
      <b-modal v-model="modal.payment.active"
              no-close-on-backdrop
              hide-header-close
              size="md">

        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="money" /></span>
          <h5 class="app-modal-header__title">{{this.modal.payment.title}}</h5>
        </div>

        <b-card>
          <b-row>
            <b-col md="12">
              <FinanceADD @getFinances="storeFinances($event)" 
                          v-if="crud.form.customers_id && crud.form.points_sales_id"
                          :points_sales="crud.form.points_sales"
                          :amount_impute="totals.total_surcharge"
                          :reset="finances.resetControl"
                          :default="finances.default"
                          :key="finances.forceUpdate" />    
            </b-col>
            <b-col md="12" class="mt-4">                                          
              <b-alert show variant="info" v-if="crud.form.payment && !parseFloat(crud.form.payment.total)">
                Si el <b>cliente paga</b> en el momento, cargue el <b>detalle de la cobranza.</b><br><br>         
                <i>En caso de no carga la cobranza, el comprobante quedará en cuenta corriente <b>pendiente de imputación</b></i>
              </b-alert>
              <div v-else>
                <b-alert show variant="success" v-if="$funciones.compareMoney(crud.form.payment.total, totals.total_surcharge) === 0">
                  Comprobante Saldado
                </b-alert>
                <div v-else>
                  <b-alert show variant="warning" v-if="$funciones.compareMoney(crud.form.payment.total, totals.total_surcharge) > 0">
                    El importe recibido es mayor al total de los comprobantes imputado.<br>
                    <b>Importe Imputado</b> {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencySale}).format(this.totals.total_surcharge)}}<br>
                    <b>Importe Recibido</b> {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencySale}).format(this.crud.form.payment.total)}}<br><br>
                    <i>El saldo quedará en cuenta corriente pendiente de imputación a favor del cliente</i>
                  </b-alert>
                  <b-alert show variant="danger" v-if="$funciones.compareMoney(crud.form.payment.total, totals.total_surcharge) < 0">
                    El importe recibido es menor al total de los comprobantes imputado.<br>
                    <b>Importe Imputado</b> {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencySale}).format(this.totals.total_surcharge)}}<br>
                    <b>Importe Recibido</b> {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencySale}).format(this.crud.form.payment.total)}}<br><br>
                    <i>El comprobante quedará en cuenta corriente pendiente de imputación</i>
                  </b-alert>              
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card>
        
        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="cancelPayment()">Cancelar</b-button>
          <b-button variant="dark" @click="save()" :disabled="isSaving" title="Finalizar (CTRL + SHIFT + ENTER)"><AppIcon name="save" class="mr-1" />Finalizar</b-button>
        </div>
      </b-modal>

      <!-- METODOS DE PAGO -->
      <b-modal v-model="modal.method_payment.active"
              no-close-on-backdrop
              hide-header-close
              size="lg">

        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="credit-card" /></span>
          <h5 class="app-modal-header__title">{{this.modal.method_payment.title}}</h5>
        </div>

        <b-row>
          <b-col lg="12">            
            <MethodPaymentSurcharge v-if="crud.form.price_list && crud.form.price_list.currency" 
                                    :amount="totals.total" 
                                    :currency="crud.form.price_list.currency.code"
                                    @setMethodPayment="setMethodPayment($event)"/>          
                                    
            <MethodPaymentSurcharge v-else  
                                    :amount="totals.total" 
                                    currency="ARS"
                                    @setMethodPayment="setMethodPayment($event)"/>          
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.method_payment.active=false">Cancelar</b-button>          
        </div>        
      </b-modal>       

      <!-- CRUD EXTRA -->
      <b-modal v-model="modal.extra.active"
              no-close-on-backdrop
              hide-header-close>

        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="list-ul" /></span>
          <h5 class="app-modal-header__title">{{this.modal.extra.title}}</h5>
        </div>

        <b-row>  
          <b-col md="12" v-if="showShipping">
            <FindObject render="search"
                        type="suppliers" 
                        @select-object="loadShipping($event)" 
                        :where="conditionSuppliersShippingActive"
                        :valueID="crud.form.shipping_id"
                        tag="Transporte"                            
                        :key="crud.form.shipping_id"
                        :showAllRegister="true"/>
          </b-col>    

          <b-col lg="12">
            <b-form-group label="Observaciones Internas" 
                          description="Estas observaciones no se muestran en la impresión">
              <app-textarea                
                v-model="crud.form.observations_internal"
                placeholder="Ingresar las observaciones internas..."
                rows="3"
                max-rows="6"
                lazy
                ref="inputObservationsInternal"
              ></app-textarea>
            </b-form-group>
          </b-col>          
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.extra.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="saveAndPayment()" title="Guardar (CTRL + SHIFT + ENTER)"><AppIcon name="save" class="mr-1" />Guardar</b-button>
        </div>
      </b-modal>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import FindObject from '@/components/inc/find/findObject'  
  import Printer from '@/components/inc/printer/printer'
  import EscposPrinter from '@/components/inc/printer/escposPrinter'
  import Detail from '@/components/inc/cpbtDetail/detail'
  import moment from 'moment'
  import AccountingEntries from '@/components/inc/accounting/entries'  
  import VoucherRelation from './inc/detailInvoice'
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import FinanceADD from '@/components/inc/finances/add'  
  import Param from '@/config/parameters'  
  import MethodPaymentSurcharge from './inc/methodPayment'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      FindObject,
      Printer,
      EscposPrinter,
      Detail,
      FormWizard,
      TabContent,
      AccountingEntries,
      VoucherRelation,
      FinanceADD,
      MethodPaymentSurcharge,
      TabHeaderActions,
    },
    data: () => {
      return {      
        access: {
          module_id: Modules.VENTAS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'salesQuick',
          elements: {
            viewDetailTabConcepts: true,
            viewDetailTabProducts: true,
            viewDetailTabProductsCompound: true,
            viewDetailTabServices: true,
          },
        },   
        parameters: {
          haveAcopio: Helper.hasParametersAccess(Param.P49),          
          freeAddTypeOperation: Helper.hasParametersAccess(Param.P61),
          haveNotIva: Helper.hasParametersAccess(Param.P65),          
        },                     
        crud: {
          form: {
            id: 0,
            date: '',
            date_expiration: '',              
            types_vouchers_id: 0,
            types_vouchers: null,
            letter: '',
            number: 0,
            methods_payment_id: 0,
            methods_payment: null,
            price_list_id: 0,
            price_list: null,
            disable_customer_price_list_fallback: false,
            points_sales_id: 0,
            points_sales: null,              
            observations: '',            
            staff_id: 0,
            sellers_id: 0,
            customers_id: 0,
            customers: null,   
            percentage_discount: 0,                                 
            detailProducts: [],
            detailProductsCompound: [],
            detailServices: [],
            detailConcepts: [],
            invoiceRelated: [],
            selectTypeVoucher: 'factura',
            selectDestination: 'default',
            accountingEntry: null,
            concepts: null,
            concepts_id: 0,
            remits: null,
            remits_id: 0,
            orders: null,
            orders_id: 0,     
            payment: [],
            showPayment: true,
            generateRemits: true,
            methods_acopio_id: 0,
            methods_acopio: null,   
            customer_name: '',
            customer_document_number: '',                        
            observations_internal: '',            
            shipping_id: 0,
            shipping: null,    
            not_iva: false,
            _idempotency_key: crypto.randomUUID(),
          },          
          formPending: [],  
          print: {
            reference: '',
            id: 0,
            key: 0,
            mode: 'pdf',
          }               
        },
        arr: {
          ivaCondition: [],
          financesCash: [],
        },
        wizard: {
          title: '',
        },
        totals: {
          subtotal: 0,
          discount: 0,
          iva: 0,
          total: 0,
          total_surcharge: 0,
          arrIva: [],                      
        },   
        modal: {
          payment: {
            active: false,
            title: '',
          },
          method_payment: {
            active: false,
            title: ''                        
          },
          extra: {
            active: false,
            title: ''            
          },                        
        },
        itemSelected: null,         
        itemDetailForceUpdate: 0,
        itemAccountingForceUpdate: 0,    
        contabilidad: {
          render: false,
          typeDebe:"",                                 
          typeHaber:"",
          defaultDebe:[],
          defaultHaber:[],
          reference:'',
          amountTotal:0
        },
        aux: {
          detailProducts: [],
          detailProductsCompound: [],
          detailServices: [],
          detailConcepts: [],          
        },
        calc: {
          discounts: 0,
        },       
        balanceCurrentAccount: 0,     
        showCustomerIdentification: true,    
        availableMethodPaymentCount: 0,
        configurations: null,
        isSaving: false,                
        finances: {
          default: null,
          staff: null,
          forceUpdate: 0,
          resetControl: false, 
        }
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      this.access.elements.viewDetailTabConcepts = Helper.hasAccessElement(this.access, 'view_detail_tab_concepts')
      this.access.elements.viewDetailTabProducts = Helper.hasAccessElement(this.access, 'view_detail_tab_products')
      this.access.elements.viewDetailTabProductsCompound = Helper.hasAccessElement(this.access, 'view_detail_tab_products_compound')
      this.access.elements.viewDetailTabServices = Helper.hasAccessElement(this.access, 'view_detail_tab_services')
      /* Fin configuracion */

      window.addEventListener("keydown", this.handlerAccessDirect);          
    },     
    destroyed() {
      window.removeEventListener("keydown", this.handlerAccessDirect);
    },
    deactivated() {
      window.removeEventListener("keydown", this.handlerAccessDirect);
    },
    mounted() {   
      this.loadConfigurations()       
      this.loadAvailableMethodsPayment()

      this._start = true
    },    
    activated() {
      if(this._start) {
        this._start = false
        return false
      }
      window.addEventListener("keydown", this.handlerAccessDirect);
      this.loadAvailableMethodsPayment()
    },      
    computed: {
      // MODULES
      moduleSellersActive() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules        
        modules.forEach(element => {
          if(element.id == Modules.VENDEDORES) {                             
            status = true                       
          }
        })        
        return status
      },
      showContabilidad() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules        
        modules.forEach(element => {
          if(element.id == Modules.CONTABILIDAD) {                             
            status = true                       
          }
        })        
        return status
      },
      showRemits() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules        
        modules.forEach(element => {
          if(element.id == Modules.REMITOS) {                             
            status = true                       
          }
        })        
        return status
      },      

      // OTHERS
      subtotalItemSelected() {
        if(this.itemSelected) {
          return parseFloat(this.itemSelected.amount_total)
        } else {
          return 0
        }
      },

      // CONDITIONS SELECT
      conditionCustomersActive(){
        return [{field: 'active', condition: true}];
      },      
      conditionPriceListActive(){
        return [{field: 'active', condition: true}];
      },      
      conditionPointsSalesActive(){
        return [{field: 'active', condition: true}];
      },
      conditionSuppliersShippingActive(){
        var condition = []
        condition.push({field: 'active', condition: true})
        condition.push({field: 'shipping', condition: true})
        return condition;
      },  

      // CANT / CURRENCY      
      getCantItemSale() {
        var cant1 = this.crud.form.detailProducts.length
        var cant2 = this.crud.form.detailProductsCompound.length
        var cant3 = this.crud.form.detailServices.length
        var cant4 = this.crud.form.detailConcepts.length

        return parseFloat(cant1 + cant2 + cant3 + cant4)
      },
      getCurrencySale() {        
        var currency = 'ARS'
        if(this.crud.form.price_list) {                    
          if(this.crud.form.price_list.currency) {                   
            currency = this.crud.form.price_list.currency.code            
          }
        }         
        return currency                      
      },
      
      // VOUCHER
      getRefVoucher() {        
        if(this.crud.form.types_vouchers && this.crud.form.points_sales && this.crud.form.number) {
          return this.crud.form.types_vouchers.name + ' '  + this.crud.form.points_sales.point_sale.toString().padStart(4,'0') + '-' + this.crud.form.number.toString().padStart(8,'0')  
        } else {
          return ''
        }      
      },

      // CONFIGURACION      
      getCurrency() {
        return 'ARS'
      },

      // VALUES DEFAULT
      customersDefault() {
        if(this.configurations) {
          return parseInt(this.configurations[1].value_number);
        } else {
          return 0;
        }
      },  
      notEditPrice() {
        if(this.configurations) {
          return this.configurations[5].value_boolean;
        } else {
          return false;
        }
      },
      showShipping() {                      
        if(this.configurations) {
          return this.configurations[6].value_boolean
        } else {
          return false
        }        
      },  
      disabledDates() {                      
        if(this.configurations) {
          return this.configurations[7].value_boolean
        } else {
          return false
        }        
      },  
      showMethodPaymentOptions() {
        return this.availableMethodPaymentCount > 1
      },

      // REMITO
      generateRemits() {
        let result = 'default'
        if(this.configurations) {
          if(this.configurations[2].value_string == 'always-remit') {
            result = 'si';
          }          
          if(this.configurations[2].value_string == 'never-remit') {
            result = 'no';
          }
        } 
        return result
      },     

      // IVA
      showCheckNotIva() {
        let status = false
        let codeAfipRI = 1 // Responsable Inscripto

        const haveNotIva = this.parameters.haveNotIva
        
        const pointsSales = this.crud.form.points_sales ? this.crud.form.points_sales : null
        const business = pointsSales ? pointsSales.business : null

        if(haveNotIva && business) {
          if(
            (business.fiscal_conditions_id == codeAfipRI && pointsSales.nd) ||
            (business.fiscal_conditions_id != codeAfipRI)
          ) {
            status = true
          } 
        }

        return status;
      }      
    },
    watch: {        
      'crud.form.customers_id': function (newQuestion, oldQuestion) {         
        this.searchVoucherByCustomer()
      },
      'crud.form.points_sales_id': function (newQuestion, oldQuestion) {                
        this.searchVoucherByCustomer()
      },
      'crud.form.price_list_id': function (newQuestion, oldQuestion) {                
        this.detailForceUpdate();
      },
      'crud.form.disable_customer_price_list_fallback': function (newQuestion, oldQuestion) {
        if(newQuestion !== oldQuestion) {
          this.detailForceUpdate();
        }
      },            
      'crud.form.detailProducts': function (newQuestion, oldQuestion) {                                
        this.searchTotalsTemporary()
      },
      'crud.form.detailProductsCompound': function (newQuestion, oldQuestion) {       
        this.searchTotalsTemporary()
      },        
      'crud.form.detailServices': function (newQuestion, oldQuestion) {        
        this.searchTotalsTemporary()
      },
      'crud.form.detailConcepts': function (newQuestion, oldQuestion) {
        this.searchTotalsTemporary()
      },      
      'crud.form.not_iva': function (newQuestion, oldQuestion) {
        this.searchTotalsTemporary()
      }              
    },    
    methods: {
      // Confirm estándar: header con ícono + tinte suave (.app-confirm-header)
      // en vez de header-bg-variant sólido, size 'sm' siempre, y
      // okVariant/headerClass según sea o no destructiva.
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      loadConfigurations() {
        var result = serviceAPI.obtenerConfiguracion()

        result.then((response) => {
          var data = response.data                  
          this.configurations = data             
          
          this.load()
          this.getIvaCondition()          
          this.showStaff()      
        })      
      },

      // SELECT
      loadCustomers (object) {        
        if(object){
          this.crud.form.customers = object
          this.crud.form.customers_id = object.id   
          
          if(object.data_fiscal) {
            if(object.data_fiscal.points_sales_id) {
              if(!this.crud.form.points_sales_id) {
                this.crud.form.points_sales = object.data_fiscal.points_sales
                this.crud.form.points_sales_id = object.data_fiscal.points_sales_id
              }
            }

            if(object.data_fiscal.methods_payment_id) {
              if(!this.crud.form.methods_payment_id) {
                this.crud.form.methods_payment = object.data_fiscal.methods_payment
                this.crud.form.methods_payment_id = object.data_fiscal.methods_payment_id                            

                let days = parseInt(object.data_fiscal.methods_payment.term)
                this.crud.form.date_expiration = moment(this.crud.form.date).add(days,'d').format('YYYY-MM-DD')
              }
            }

            if(object.data_fiscal.methods_acopio_id) {
              if(!this.crud.form.methods_acopio_id) {
                this.crud.form.methods_acopio = object.data_fiscal.methods_acopio
                this.crud.form.methods_acopio_id = object.data_fiscal.methods_acopio_id
              }
            }     

            if(object.data_fiscal.shipping_id) {
              if(!this.crud.form.shipping_id) {
                this.crud.form.shipping = object.data_fiscal.shipping
                this.crud.form.shipping_id = object.data_fiscal.shipping_id
              }
            }                       
          }
          
          if(!this.crud.form.price_list_id) {
            if(!this.crud.form.disable_customer_price_list_fallback && object.price_list) {
              if(object.price_list.list) {              
                this.crud.form.price_list = object.price_list.list
                this.crud.form.price_list_id = object.price_list.list.id
                this.crud.form.disable_customer_price_list_fallback = false
              }
            }          
          }    
          
          this.getBalanceCurrentAccount()
        } else {
          this.crud.form.customers = null
          this.crud.form.customers_id = 0
          this.crud.form.disable_customer_price_list_fallback = false

          this.balanceCurrentAccount = 0
        }
      }, 
      loadPointsSales (object) {                
        if(object){
          this.crud.form.points_sales = object
          this.crud.form.points_sales_id = object.id       

          // Resetear not_iva y solo cargarlo si el check debe mostrarse
          this.crud.form.not_iva = false
          // Los computed properties se evalúan síncronamente, no necesitamos $nextTick
          if(this.showCheckNotIva) {
            this.crud.form.not_iva = object.not_iva
          }         
          
          this.getBalanceCurrentAccount()
          this.getFinancesCash()       
        } else {
          this.crud.form.points_sales = null
          this.crud.form.points_sales_id = 0
          this.crud.form.not_iva = false

          this.getBalanceCurrentAccount()
        }
      },      
      loadMethodsPayment (object) {
        if(object){
          this.crud.form.methods_payment = object
          this.crud.form.methods_payment_id = object.id             

          let days = parseInt(object.term)
          this.crud.form.date_expiration = moment(this.crud.form.date).add(days,'d').format('YYYY-MM-DD')                          
        } else {
          this.crud.form.methods_payment = null
          this.crud.form.methods_payment_id = 0
        }
      },
      loadMethodsAcopio (object) {
        if(object){
          this.crud.form.methods_acopio = object
          this.crud.form.methods_acopio_id = object.id             
        } else {
          this.crud.form.methods_acopio = null
          this.crud.form.methods_acopio_id = 0
        }
      },         
      loadPriceList (object) {
        if(object){
          this.crud.form.price_list = object
          this.crud.form.price_list_id = object.id
          this.crud.form.disable_customer_price_list_fallback = false
        } else {
          this.crud.form.price_list = null
          this.crud.form.price_list_id = 0
          this.crud.form.disable_customer_price_list_fallback = true
        }
      },        
      loadShipping (object) {        
        if(object){
          this.crud.form.shipping = object
          this.crud.form.shipping_id = object.id             
        } else {
          this.crud.form.shipping = null
          this.crud.form.shipping_id = 0
        }        

        if(this.$refs.inputObservationsInternal) {
          this.$refs.inputObservationsInternal.focus()
        }
      },   

      // AMOUNT CURRENT ACCOUNT
      getBalanceCurrentAccount() {
        var result = serviceAPI.filtrarCurrentsAccountsBalance({
          customers_id: this.crud.form.customers_id,
          points_sales_id: this.crud.form.points_sales_id, 
        })

        result.then((response) => {
          var data = response.data
          this.balanceCurrentAccount = data
        })
      },

      // ABM MAIN
      load(type='start') {
        this.crud.form._idempotency_key = crypto.randomUUID()
        this.crud.form.id = 0           
        this.crud.form.observations = ''
        this.crud.form.staff_id = Helper.getStaffId()
        this.crud.form.sellers_id = 0
        this.crud.form.percentage_discount = 0                                 
        this.crud.form.detailProducts = []
        this.crud.form.detailProductsCompound = []
        this.crud.form.detailServices = []
        this.crud.form.detailConcepts = []
        this.balanceCurrentAccount = 0

        if(this.generateRemits == 'default') {
          this.crud.form.generateRemits = true
        } else {
          if(this.generateRemits == 'si') {
            this.crud.form.generateRemits = true
          } else if (this.generateRemits == 'no') {
            this.crud.form.generateRemits = false
          }
        }                  

        if(type == 'start') {             
          if(!this.customersDefault) {
            this.crud.form.customers_id = 0
            this.crud.form.customers = null               
          } else {
            this.crud.form.customers_id = this.customersDefault            
          }          
             
          this.crud.form.points_sales_id = 0
          this.crud.form.points_sales = null  
          this.crud.form.methods_payment_id = 0
          this.crud.form.methods_payment = null      
          this.crud.form.price_list_id = 0
          this.crud.form.price_list = null
          this.crud.form.disable_customer_price_list_fallback = false
          this.crud.form.date = moment().format('YYYY-MM-DD')
          this.crud.form.date_expiration = moment().add(10,'d').format('YYYY-MM-DD')        
          this.crud.form.methods_acopio_id = 0
          this.crud.form.methods_acopio = null    
          this.crud.form.shipping_id = 0
          this.crud.form.shipping = null   
          
          this.crud.form.not_iva = false
        } 

        if(type == 'restart') {
          this.crud.form.observations_internal = ''                            
          this.crud.form.shipping_id = 0
          this.crud.form.shipping = null          

          this.searchVoucherByCustomer()

          this.detailForceUpdate();
          this.forceUpdate();
        }
				
        this.crud.form.payment = []           
        this.financesForceUpdate()

        this.wizard.title = "Nueva Factura"
        this.wizard.subtitle = ""
				
        this.crud.form.selectTypeVoucher = 'factura'
        this.crud.form.selectDestination = 'default'   
        
        this.crud.form.customer_name = ''
        this.crud.form.customer_document_number = ''            
      },

      preSave() {
        if(this.showShipping) {
          this.modal.extra.title = "Información Extra"
          this.modal.extra.active = true
        } else {
          this.saveAndPayment()
        }
      },
      saveAndPayment() {
        this.modal.extra.active = false

        this.finances.resetControl = true

        this.modal.payment.title = "Detalle del pago"
        this.modal.payment.active = true
      }, 
      cancelPayment() {        
        if(this.$refs.wizard) {            
          this.$refs.wizard.changeTab(2,1)
        }           

        this.modal.payment.active=false
      },                          
      save() {
        if (this.isSaving) return;
        this.isSaving = true;

        let loader = this.$loading.show();
        
        var result = serviceAPI.agregarComprobante(this.crud.form);
        
        result.then((response) => {
          var data = response.data
          this.sendPrinterSale(data, true)

          this.modal.extra.active = false

          this.modal.payment.active = false
          this.finances.resetControl = true

          loader.hide()
          this.isSaving = false;
          this.load('restart')      

          if(this.$refs.wizard) {            
            this.$refs.wizard.changeTab(2,1)
          }          
                        
          this.$awn.success("Comprobante generado con éxito");              
        })
        .catch(error => {
          this.modal.extra.active = false

          this.modal.payment.active = false
          this.finances.resetControl = true

          loader.hide()
          this.isSaving = false;
          // Conserva la clave para que un reintento recupere la misma venta si
          // el servidor confirmó el comprobante pero la respuesta se perdió.

          if(this.$refs.wizard) {
            this.$refs.wizard.changeTab(2,1)
          }

          this.$awn.alert(Error.showError(error));
        })              
      },          
      cancel() {
        this.confirmDialog('¿Desea reiniciar el comprobante?', {
          title: 'Reiniciar Comprobante',
          icon: 'refresh',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {        
            this.load('start')      

            if(this.$refs.wizard) {            
              this.$refs.wizard.changeTab(0,0)
            } 
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })   
      },              
      setDetailItems(event, type) { 
        if(type=="products") {
          this.crud.form.detailProducts = event                
        } 
        if(type=="productsCompound") {          
          this.crud.form.detailProductsCompound = event                
        }               
        if(type=="services") {
          this.crud.form.detailServices = event                
        } 
        if(type=="concepts") {
          this.crud.form.detailConcepts = event                
        }                 
      },
      detailForceUpdate() {
        this.itemDetailForceUpdate = this.itemDetailForceUpdate + 1
      },

      // VALID
      saleValidCrudGeneral() {        
        this.searchTotalsTemporary()  
        
        if(this.crud.form.customers_id && this.crud.form.points_sales_id  && this.crud.form.methods_payment_id) {
          return true;
        } else {
          if(!this.crud.form.customers_id) {
            this.$awn.alert("No se cargó el cliente");
            return false;
          }
          if(!this.crud.form.points_sales_id) {
            this.$awn.alert("No se cargó el punto de venta");
            return false;
          }                        
          if(!this.crud.form.methods_payment_id) {
            this.$awn.alert("No se cargó la condición de pago");
            return false;
          }                         
        }        
      },
      saleValidCrudDetail() {
        if( this.crud.form.detailProducts.length || 
            this.crud.form.detailProductsCompound.length || 
            this.crud.form.detailServices.length || 
            this.crud.form.detailConcepts.length) {
          this.getContabilidad()          
          return true;
        } else {
          this.$awn.alert("No se cargó ningún item");
          return false;
        }
      },
      salesValidCrudAccounting() {        
        if(this.crud.form.accountingEntry) {
          return true
        } else {
          this.$awn.alert("Revisar el Asiento Contable");
          return false
        }
      },    

      // SELECT VOUCHER 
      searchVoucherByCustomer() {
        if(!this.crud.form.id) {
          if(this.crud.form.customers_id && this.crud.form.points_sales_id ) {
            var result = serviceAPI.obtenerVoucherByCustomer({
              'customers_id': this.crud.form.customers_id,
              'point_sale_id': this.crud.form.points_sales_id,
							'reference': this.crud.form.selectTypeVoucher,
            });
            result.then((response) => {    
							this.crud.form.types_vouchers_id = response.data[0].id							
							this.searchVoucher()                          
            })
						.catch(error => {
							this.$awn.alert(Error.showError(error));
						})   						           
          }
        } else {                                      
          if( this.crud.form.types_vouchers ) {    
            // simple                      
            var titleVoucher = ''
            titleVoucher = titleVoucher + this.crud.form.types_vouchers.name
            titleVoucher = titleVoucher +  ' ' + this.crud.form.points_sales.point_sale.toString().padStart(4,'0')
            titleVoucher = titleVoucher +  '-' + this.crud.form.number.toString().padStart(8,'0')

            if(this.crud.form.points_sales && !this.crud.form.points_sales.nd) {
              if(this.crud.form.points_sales.status) {
                if(this.crud.form.points_sales.afip_production) {
                  this.wizard.title = titleVoucher + ' (CONECTADO ARCA)'
                } else {
                  this.wizard.title = titleVoucher + ' (CONECTADO ARCA - HOMOLOGACIÓN)'
                }                    
              } else {
                this.wizard.title = titleVoucher + ' (DESCONECTADO ARCA)'
              }
            } else {
              this.wizard.title = titleVoucher
            }
          }                   
        }
      },			
      searchVoucher() {
        if(!this.crud.form.id) {
          if(this.crud.form.customers_id && this.crud.form.points_sales_id ) {
            var result = serviceAPI.obtenerVoucherById({
              'points_sales_id': this.crud.form.points_sales_id,
              'types_vouchers_id' : this.crud.form.types_vouchers_id,
            });
            result.then((response) => {                      
              this.crud.form.types_vouchers = response.data.type_voucher
              this.crud.form.letter = response.data.type_voucher.letter                    
              this.crud.form.number = response.data.number
              
              if( this.crud.form.types_vouchers ) {              
                // simple
                var titleVoucher = ''
                titleVoucher = titleVoucher + this.crud.form.types_vouchers.name
                titleVoucher = titleVoucher +  ' ' + this.crud.form.points_sales.point_sale.toString().padStart(4,'0')
                titleVoucher = titleVoucher +  '-' + this.crud.form.number.toString().padStart(8,'0')

                if(this.crud.form.points_sales && !this.crud.form.points_sales.nd) {
                  if(this.crud.form.points_sales.status) {
                    if(this.crud.form.points_sales.afip_production) {
                      this.wizard.title = titleVoucher + ' (CONECTADO ARCA)'
                    } else {
                      this.wizard.title = titleVoucher + ' (CONECTADO ARCA - HOMOLOGACIÓN)'
                    }                    
                  } else {
                    this.wizard.title = titleVoucher + ' (DESCONECTADO ARCA)'
                  }
                } else {
                  this.wizard.title = titleVoucher
                }     
              }
                          
            })           
          }
        } else {                                      
          if( this.crud.form.types_vouchers ) {                          
            // simple
            var titleVoucher = ''
            titleVoucher = titleVoucher + this.crud.form.types_vouchers.name
            titleVoucher = titleVoucher +  ' ' + this.crud.form.points_sales.point_sale.toString().padStart(4,'0')
            titleVoucher = titleVoucher +  '-' + this.crud.form.number.toString().padStart(8,'0')

            if(this.crud.form.points_sales && !this.crud.form.points_sales.nd) {
              if(this.crud.form.points_sales.status) {
                if(this.crud.form.points_sales.afip_production) {
                  this.wizard.title = titleVoucher + ' (CONECTADO ARCA)'
                } else {
                  this.wizard.title = titleVoucher + ' (CONECTADO ARCA - HOMOLOGACIÓN)'
                }                    
              } else {
                this.wizard.title = titleVoucher + ' (DESCONECTADO ARCA)'
              }
            } else {
              this.wizard.title = titleVoucher
            }                             
          }                   
        }
      },
      searchTotalsTemporary() {
        if(this.crud.form.detailProducts || this.crud.form.detailProductsCompound || this.crud.form.detailServices || this.crud.form.detailConcepts) {
          var result = serviceAPI.obtenerVoucherTotalsTemporary({
            'header': this.crud.form,
            'detailsProducts': this.crud.form.detailProducts,
            'detailsProductsCompound': this.crud.form.detailProductsCompound,   
            'detailsServices': this.crud.form.detailServices,
            'detailsConcepts': this.crud.form.detailConcepts,
            'methods_payment': this.crud.form.methods_payment,
          });
          result.then((response) => {             
            var data = response.data   
            
            this.aux.detailProducts = data.detailProducts
            this.aux.detailProductsCompound = data.detailProductsCompound
            this.aux.detailServices = data.detailServices
            this.aux.detailConcepts = data.detailConcepts

            this.totals.subtotal = data.amount_net
            this.totals.discount = data.amount_discount
            this.totals.subtotal_discount = data.amount_subtotal
            this.totals.iva = data.amount_iva
            this.totals.total = data.amount_total
            this.totals.total_surcharge = data.amount_total_surcharge
            this.totals.arrIva = data.arrIva
          })           
        }                   
      },
      validDiscounts() {
        if(this.crud.form.percentage_discount=='') {          
          this.crud.form.percentage_discount = 0
        } else {          
          if( parseFloat(this.crud.form.percentage_discount) < 0 || 
              parseFloat(this.crud.form.percentage_discount) > 100 ) {            
            this.crud.form.percentage_discount = 0
          } 
        }       
        this.searchTotalsTemporary()
      },    
      

      // FINANCES
      getFinancesCash() {
        serviceAPI.obtenerCajas().then((response) => {
          const data = response.data;
          this.arr.financesCash = [];

          const freeMode = this.parameters.freeAddTypeOperation;
          const formPS = this.crud.form.points_sales || {};
          const userCashId = this.finances.staff && this.finances.staff.cash_id;
          const pointCashId = formPS.cash_id;
          const formNd = formPS.nd;

          // Validación ND (si no está en modo libre)
          const isValidND = (cash) => {
            return freeMode || (cash.nd === formNd);
          };

          // 1. Agregar la caja del usuario si la tiene y pasa validación
          if (userCashId) {
            const userCash = data.find(cash => cash.id === userCashId && isValidND(cash));
            if (userCash) this.arr.financesCash.push(userCash);
          }

          // 2. Si no hay caja de usuario, agregar la del punto de venta si pasa validación
          if (!userCashId && pointCashId) {
            const pointCash = data.find(cash => cash.id === pointCashId && isValidND(cash));
            if (pointCash) this.arr.financesCash.push(pointCash);
          }

          // 3. Agregar cajas compartidas que pasen validación
          data.forEach(cash => {
            if (cash.shared && isValidND(cash)) {
              // Evitar duplicados si ya se agregó
              const exists = this.arr.financesCash.find(c => c.id === cash.id);
              if (!exists) this.arr.financesCash.push(cash);
            }
          });

          // 4. Si no hay caja de usuario ni del punto de venta, agregar todas que pasen validación
          if (!userCashId && !pointCashId) {
            data.forEach(cash => {
              if (isValidND(cash)) {
                const exists = this.arr.financesCash.find(c => c.id === cash.id);
                if (!exists) this.arr.financesCash.push(cash);
              }
            });
          }
        });
      },             
      transformFinances(id) {
        this.financesForceUpdate()
        
        setTimeout(()=>{
          if(this.totals.total_surcharge) {            
            let cash = this.arr.financesCash.find(cash => parseInt(cash.keyaccess) === parseInt(id));            
            
            if(cash) {
              let cash_id = cash.id            

              let item = {
                cash: {
                  detail: [
                    {
                      cash: cash,
                      cash_id: cash_id,
                      total: this.totals.total_surcharge,
                    },              
                  ],
                  total: this.totals.total_surcharge,
                },
                cheques: {
                  detail: null,
                  total: 0,
                },
                total: this.totals.total_surcharge,
                totalFormat: Intl.NumberFormat('es-AR',{style:'currency',currency: this.getCurrency}).format(this.totals.total_surcharge),
              }
            
              this.finances.resetControl = true
              this.finances.default = item        
            
              this.$awn.info("PAGO CON: <b>" + cash.name + '</b> - <b>' + item.totalFormat + '</b>');               

              this.storeFinances(item)
            } else {
              this.$awn.warning("Caja/Banco <b>NO DISPONIBLE</b>");               
            }
          }
        },100)
      },
      storeFinances(values) {        
        this.crud.form.payment = values           
        this.crud.form.payment.totalFormat = Intl.NumberFormat('es-AR',{style:'currency',currency: this.getCurrencySale}).format(this.crud.form.payment.total)

        this.finances.resetControl = false
      },      
      financesForceUpdate() {
        this.finances.forceUpdate = this.finances.forceUpdate + 1
      },
      showStaff()  {
        let staffID = Helper.getStaffId()
        var result = serviceAPI.mostrarStaff(staffID)

        result.then((response) => {
          var data = response.data
          if(data) {
            this.finances.staff = data
          } else {
            this.finances.staff = null
          }                     
        })          
      },      
    
      // RECARGO CONDICION DE PAGO
      loadAvailableMethodsPayment() {
        var result = serviceAPI.obtenerMetodosPagos()
        result.then((response) => {
          var data = Array.isArray(response.data) ? response.data : []
          this.availableMethodPaymentCount = data.length
        })
        .catch(() => {
          this.availableMethodPaymentCount = 0
        })
      },
      showSurchargeMethodPayment() {
        this.modal.method_payment.title = "Condiciones de Pago Disponibles"
        this.modal.method_payment.active = true          
      },
      setMethodPayment(object) {      
        if(object){
          this.crud.form.methods_payment = object
          this.crud.form.methods_payment_id = object.id             

          let days = parseInt(object.term)
          this.crud.form.date_expiration = moment(this.crud.form.date).add(days,'d').format('YYYY-MM-DD')                          
        }  
                
        this.searchTotalsTemporary()  
        this.modal.method_payment.active=false
      },

      // PRINT
      sendPrinterSale(item, automatic = false) {
        // "No imprimir" aplica al envío automático de comprobantes térmicos.
        // PDF y el método de reimpresión manual no se restringen.
        if(automatic && (item.print_mode || 'pdf') == 'thermal_printer') {
          serviceAPI.obtenerStaffThermalPrinter()
          .then((response) => {
            if(response.data.thermal_printer_mode != 'disabled') {
              this.openPrinterSale(item)
            }
          })
          .catch(() => this.openPrinterSale(item))
          return
        }

        this.openPrinterSale(item)
      },
      openPrinterSale(item) {
        this.crud.print.key=Math.random()
        this.crud.print.id=item.id
        this.crud.print.reference = item.reportDefault
        this.crud.print.mode = item.print_mode || 'pdf'
      },
      
      // ACCESSOS DIRECTOS
      handlerAccessDirect(e) {                           
        // ctrl + shift + enter = 13
        if (e.ctrlKey && e.shiftKey && e.keyCode === 13) {
          e.preventDefault(); 
          
          if(this.modal.extra.active) {
            this.saveAndPayment()
          } else if(this.modal.payment.active){
            if (!this.isSaving) {
              this.save()                  
            }
          } else {
            if(this.$refs.wizard) {            
              this.$refs.wizard.nextTab();            
            }              
          }              
        }  
        
        
        // f2 = 113
        if (e.keyCode === 113) {           
          if(this.$refs.searchCustomer) {
            this.$refs.searchCustomer.openSearch()
          }
        }         

        // ctrl + shift + number (0-9)        
        if(this.modal.payment.active){
          let isKeyNumber = e.code.includes('Numpad') || e.code.includes('Digit')
          let isCtrl = e.ctrlKey
          let isShift = e.shiftKey  
          
          if (isKeyNumber) {
            if(isCtrl || isShift) {
              e.preventDefault();

              let id = parseInt(e.code.slice(-1))
              if(!isNaN(id)) {
                this.transformFinances(id)
              }                 
            }          
          } 
        }  
      },        

      /****************
       * CONTABILIDAD *
       * **************/      
      getContabilidad() {          
        this.contabilidad.render = false
        this.contabilidad.typeDebe = ""
        this.contabilidad.typeHaber = "",
        this.contabilidad.defaultDebe = []
        this.contabilidad.defaultHaber = []
        this.contabilidad.reference = this.getRefVoucher
        this.contabilidad.amountTotal = parseFloat(this.totals.total_surcharge)
        
        // ASIENTO POR DEFECTO 
        if( this.crud.form.selectTypeVoucher == 'factura' || 
            this.crud.form.selectTypeVoucher == 'notadebito') {              
          this.contabilidad.defaultDebe = this.getContabilidadAsientoVenta('debe')
          this.contabilidad.defaultHaber = this.getContabilidadAsientoVenta('haber')
        } 
        // END
        
        this.contabilidad.render = true
        this.forceUpdate()

        setTimeout(()=>{
          if(this.crud.form.accountingEntry) {
            this.saveAndPayment()
          } 
        },100)       
      },

      getAsiento(object) {
        this.crud.form.accountingEntry = object
      },
      forceUpdate() {
        this.itemAccountingForceUpdate = this.itemAccountingForceUpdate + 1
      },

      getIvaCondition() {
        var result = serviceAPI.obtenerCondicionesIva()        
        result.then((response) => {
          var data = response.data    
          this.arr.ivaCondition = data          
        })   
      },  

      getContabilidadAsientoVenta(type) {                     
        if(type == 'debe') {        
          
          var arrDebe = []

          var totalConcepts = 0
          if(this.aux.detailConcepts) {
            this.aux.detailConcepts.forEach(element => {                   
              totalConcepts = totalConcepts + parseFloat(element.price) + parseFloat(element.iva)

              arrDebe.push(
                {
                  account: element.concepts.accounting_account_default,
                  amount: parseFloat(element.price) + parseFloat(element.iva),
                  disabled: true,
                }
              )
            });
          }

          if( parseFloat(this.totals.total_surcharge) > totalConcepts ) {
            arrDebe.push(
              {
                account: this.crud.form.customers.accounting_account_default,
                amount: parseFloat(this.totals.total_surcharge) - totalConcepts,
                disabled: true,
              }
            )
          }

          return arrDebe
        }        

        if(type == 'haber') {        
          var arrHaber = [
            {
              account: this.crud.form.customers.accounting_account_secondary,
              amount: parseFloat(this.totals.total_surcharge) - parseFloat(this.totals.iva),
              disabled: true,
            }
          ]

          if(this.totals.arrIva) {
            Object.entries(this.totals.arrIva).forEach(([index1, element1]) => {              
              this.arr.ivaCondition.forEach(element2 => {              
                if(index1 == element2.id) {
                  arrHaber.push({
                    account: element2.accounting_account_default,
                    amount: parseFloat(element1),
                    disabled: true,                  
                  })
                }
              });
            })
            
          }     
          
          return arrHaber
        }        
      },          
    }
  }
</script>
<style>
  .crud-sales-title {
    font-size: 15px;
    font-weight: 600;
  }
  .crud-sales-wizard .wizard-header {
    padding: 0px;
  }
  .crud-sales-wizard .wizard-card-footer {
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 4px 0;
  }
  .crud-sales-wizard .wizard-card-footer .wizard-footer-left,
  .crud-sales-wizard .wizard-card-footer .wizard-footer-right { float: none !important; }
  .crud-sales-wizard .wizard-card-footer .wizard-footer-right { margin-left: auto; }
  .crud-sales-wizard .wizard-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 112px;
    height: 36px;
    padding: 6px 14px;
    border-width: 1px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: var(--app-font-semibold);
    box-shadow: none;
    transition: background-color .15s ease, border-color .15s ease, color .15s ease;
  }
  .crud-sales-wizard .wizard-footer-left .wizard-btn::before,
  .crud-sales-wizard .wizard-footer-right .wizard-btn::after {
    font-family: 'Material Symbols Rounded';
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    font-feature-settings: 'liga';
    line-height: 1;
  }
  .crud-sales-wizard .wizard-footer-left .wizard-btn::before { content: 'arrow_back'; margin-right: 6px; }
  .crud-sales-wizard .wizard-footer-right .wizard-btn::after { content: 'arrow_forward'; margin-left: 6px; }
  .crud-sales-wizard .wizard-footer-left .wizard-btn {
    background-color: var(--app-color-surface) !important;
    border-color: var(--app-color-border-strong) !important;
    color: var(--app-color-text-secondary) !important;
  }
  .crud-sales-wizard .wizard-footer-left .wizard-btn:hover {
    background-color: var(--app-color-surface-subtle) !important;
    color: var(--app-color-text) !important;
  }
  .crud-sales-wizard .wizard-footer-right .wizard-btn {
    background-color: var(--app-color-primary) !important;
    border-color: var(--app-color-primary) !important;
    color: #fff !important;
  }
  .crud-sales-wizard .wizard-footer-right .wizard-btn:hover { filter: brightness(.94); }
  @media (max-width: 767.98px) {
    .crud-sales-wizard .wizard-card-footer { gap: 8px; padding: 12px 0 0; }
    .crud-sales-wizard .wizard-footer-left,
    .crud-sales-wizard .wizard-footer-right { display: flex; flex: 1 1 0; }
    .crud-sales-wizard .wizard-card-footer .wizard-footer-right { margin-left: 0; }
    .crud-sales-wizard .wizard-footer-left > span,
    .crud-sales-wizard .wizard-footer-right > span { display: block; width: 100%; }
    .crud-sales-wizard .wizard-btn { width: 100%; min-width: 0; }
    .crud-sales-detail-options > [class*="col-"] + [class*="col-"] { margin-top: 8px; }
    .crud-sales-detail-options .pull-left,
    .crud-sales-detail-options .pull-right { float: none !important; }
  }
  .crud-sales-wizard .wizard-title {
    text-align: left;
  }
  .crud-sales-wizard .category {
    text-align: left;
  }

  /* Stat "Items" y cajita de totales (Subtotal/Descuento/Subtotal/IVA/Total)
     — mismo patrón tokenizado que sales.vue (docs/modal-interfaces, sección 7). */
  .crud-sales-stat {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px 8px;
    border: 1px solid var(--app-color-border);
    border-radius: 8px;
    background: var(--app-color-surface-subtle);
  }
  .crud-sales-stat__label {
    color: var(--app-color-text-muted);
    font-size: var(--app-text-xs);
    font-weight: var(--app-font-semibold);
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }
  .crud-sales-stat__value {
    font-size: 22px;
    font-weight: var(--app-font-semibold);
    color: var(--app-color-text);
  }
  .crud-sales-totals {
    border: 1px solid var(--app-color-border);
    border-radius: 8px;
    background: var(--app-color-surface-subtle);
    padding: 10px 12px;
  }
  .crud-sales-totals__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 4px 0;
    font-size: 12px;
  }
  .crud-sales-totals__row + .crud-sales-totals__row {
    border-top: 1px dashed var(--app-color-border);
  }
  .crud-sales-totals__label {
    color: var(--app-color-text-muted);
    font-weight: var(--app-font-semibold);
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 0.02em;
    flex: 1 1 auto;
    min-width: 0;
  }
  .crud-sales-totals__value {
    font-weight: var(--app-font-semibold);
    text-align: right;
    white-space: nowrap;
    flex: 0 0 auto;
  }
  .crud-sales-totals__row--total {
    border-top: 2px solid var(--app-color-primary) !important;
    margin-top: 4px;
    padding-top: 8px;
  }
  .crud-sales-totals__row--total .crud-sales-totals__label,
  .crud-sales-totals__row--total .crud-sales-totals__value {
    font-size: 14px;
    color: var(--app-color-text);
  }
  .crud-sales-totals__discount-group {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 0 0 auto;
  }
  .crud-sales-totals__discount {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .crud-sales-totals__discount input {
    width: 62px;
    height: 26px;
    padding: 2px 4px;
    text-align: right;
  }
  .crud-sales-totals__discount-suffix {
    color: var(--app-color-text-muted);
    font-size: 12px;
  }
</style>
